import {ReactNode} from 'react';
import Styles from './CardSubtitle.module.scss';

export const CardSubtitle = ({children}: {children: ReactNode}) => {
  return <h3 className={Styles.subtitle}>{children}</h3>;
};

CardSubtitle.displayName = 'Card.Subtitle';
